import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { useLocation, useNavigate } from "react-router";
import { editvoucher } from "../../service/Mainservice";
import Loader from "../../Loader/Loader";

const validate = (values) => {
  const errors = {};
  console.log(values);

  if (!values.code) {
    errors.code = "Required";
  }
  if (!values.discountType) {
    errors.discountType = "Required";
  }
  if (!values.discountValue) {
    errors.discountValue = "Required";
  }
  if (!values.minOrderValue) {
    errors.minOrderValue = "Required";
  }
  if (!values.expiryDate) {
    errors.expiryDate = "Required";
  }
  if (!values.usageLimit) {
    errors.usageLimit = "Required";
  }
  return errors;
};

const EditVoucher = () => {
  const [load, setload] = useState(false);

  const [success, setsuccess] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open, setOpen] = useState(false);
  const [err, seterr] = useState("");
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();
  const items = location.state.item;

  const formik = useFormik({
    initialValues: {
      code: items.code,
      discountType: items.discountType,
      discountValue: items.discountValue,
      maxDiscount: items.maxDiscount,
      minOrderValue: items.minOrderValue,
      expiryDate: items.expiryDate.toString().split("T")[0],
      usageLimit: items.usageLimit,
      createdBy: "1",
    },
    validate: (values) => validate(values, isInitialLoad),
    onSubmit: (values) => {
      handleAdd(values);
    },
  });
  useEffect(() => {
    formik.setValues(
      {
        code: items.code,
        discountType: items.discountType,
        discountValue: items.discountValue,
        maxDiscount: items.maxDiscount,
        minOrderValue: items.minOrderValue,
        expiryDate: items.expiryDate.toString().split("T")[0],
        usageLimit: items.usageLimit,
        createdBy: "1",
      },
      false
    );
    formik.validateForm();
  }, [items]);
  console.log(formik.errors);

  const handleAdd = async (values) => {
    setload(true);
    try {
      const params={
        id:items.id,
        ...values
      }
      const response = await editvoucher(params);
      setsuccess(response.data.message);
      setOpen2(true);
      setload(false);
      setTimeout(() => {
        navigate("/Voucher_List");
      }, 1000);
    } catch (error) {
      seterr(error.message);
      setOpen(true);
      setload(false);
    }
  };

  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">Edit Voucher</h1>
        </div>
        <form onSubmit={formik.handleSubmit} className="interview_form">
          <div>
            <label className="Auth_label">Code</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="code"
              type="text"
              minLength={1}
              maxLength={200}
              value={formik.values.code}
              className="Auth_input"
            />
            {formik.errors.code ? (
              <p className="invalid">{formik.errors.code} </p>
            ) : null}
          </div>
          <div>
            <label className="Auth_label">Select Discount Type</label>
            <br />
            <select
              onChange={formik.handleChange}
              name="discountType"
              value={formik.values.discountType}
              className="Auth_input"
            >
              <option value="percentage">Percentage</option>
              <option value="flat">Flat</option>
            </select>
            {formik.errors.discountType ? (
              <p className="invalid">{formik.errors.discountType} </p>
            ) : null}
          </div>

          <div>
            <label className="Auth_label">Discount Value</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="discountValue"
              type="number"
              minLength={1}
              maxLength={200}
              value={formik.values.discountValue}
              className="Auth_input"
            />
            {formik.errors.discountValue ? (
              <p className="invalid">{formik.errors.discountValue} </p>
            ) : null}
          </div>
          {formik.values.discountType === "percentage" && (
            <div>
              <label className="Auth_label">Max Discount</label>
              <br />
              <input
                onChange={formik.handleChange}
                name="maxDiscount"
                type="number"
                minLength={1}
                maxLength={200}
                value={formik.values.maxDiscount}
                className="Auth_input"
              />
              {formik.errors.maxDiscount ? (
                <p className="invalid">{formik.errors.maxDiscount} </p>
              ) : null}
            </div>
          )}
          <div>
            <label className="Auth_label">Min Order</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="minOrderValue"
              type="number"
              minLength={1}
              maxLength={200}
              value={formik.values.minOrderValue}
              className="Auth_input"
            />
            {formik.errors.minOrderValue ? (
              <p className="invalid">{formik.errors.minOrderValue} </p>
            ) : null}
          </div>
          <div>
            <label className="Auth_label">Expiry Date</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="expiryDate"
              type="date"
              value={formik.values.expiryDate}
              className="Auth_input"
            />
            {formik.errors.expiryDate ? (
              <p className="invalid">{formik.errors.expiryDate} </p>
            ) : null}
          </div>
          <div>
            <label className="Auth_label">Usage Limit</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="usageLimit"
              type="number"
              minLength={1}
              maxLength={200}
              value={formik.values.usageLimit}
              className="Auth_input"
            />
            {formik.errors.usageLimit ? (
              <p className="invalid">{formik.errors.usageLimit} </p>
            ) : null}
          </div>
          <div />
          <button className="term_button" type="Submit">
            {load ? "Updating..." : "Save"}
          </button>
        </form>
      </div>
      <Snackbar
        open={open}
        autoHideDuration={2000}
        onClose={() => setOpen(false)}
      >
        <Alert severity="error" variant="filled" sx={{ width: "70vw" }}>
          {err}
        </Alert>
      </Snackbar>
      <Snackbar
        open={open2}
        autoHideDuration={2000}
        onClose={() => setOpen2(false)}
      >
        <Alert severity="success" variant="filled" sx={{ width: "70vw" }}>
          {success}
        </Alert>
      </Snackbar>
    </>
  );
};
export default EditVoucher;
